import { createAction } from 'redux-actions'

export const onSetsessionSate = createAction('SET_SETSESSION_SATE')
export const resetSessionState = createAction('RESET_SESSION_STATE')
